<!-- Toolbar -->
<mat-toolbar class="main-toolbar">
  <!-- Left -->
  <div class="h-100 d-flex gap-2 align-items-center">
    <img
      class="h-75 mr-4 cursor--pointer"
      src="/nle-logo-white.png"
      alt="logo"
      routerLink="/"
    >
    <span style="font-size: 16px;color: rgb(255 255 255 / 95%);">| Beheer initiatieven</span>
  </div>
  <!-- End left -->
  <!-- Center. Both screens are admin-only, so non-admins get no navigation -->
  @if (user().isAdmin) {
    <div class="d-flex gap-4">
      <a
        class="toolbar-link"
        routerLink="/organization-list"
        routerLinkActive="toolbar-link--active"
      >
        <mat-icon fontSet="material-symbols-outlined">groups</mat-icon>
        Initiatieven
      </a>
      <a
        class="toolbar-link"
        routerLink="/ownership-claim-list"
        routerLinkActive="toolbar-link--active"
      >
        @if (openClaimRequestCount() > 0) {
          <span
            class="toolbar-link__badge"
            [attr.aria-label]="openClaimRequestCount() + ' openstaande aanvragen'"
          >
            {{ openClaimRequestCount() > 99 ? '99+' : openClaimRequestCount() }}
          </span>
        }
        <mat-icon fontSet="material-symbols-outlined">assignment_ind</mat-icon>
        Aanvragen
      </a>
    </div>
  }
  <!-- End center -->
  <!-- Right -->
  <div>
    <button mat-icon-button [matMenuTriggerFor]="userMenu">
      <mat-icon>person</mat-icon>
    </button>
    <mat-menu #userMenu="matMenu">
      <!-- User name -->
      <button mat-menu-item disabled class="text-capitalize">
        {{ userInformation.name }}
      </button>
      <!-- Log out -->
      <button mat-menu-item (click)="logOut()">
        <mat-icon fontSet="material-symbols-outlined">logout</mat-icon>
        Log out
      </button>
      <!-- Version -->
      <mat-divider></mat-divider>
      <a mat-menu-item disabled>
        <mat-icon fontSet="material-symbols-outlined">commit</mat-icon>
        <span>Version:&nbsp;{{ packageService.getAppVersion() }}</span>
      </a>
    </mat-menu>
  </div>
  <!-- End right -->
</mat-toolbar>
<!-- End toolbar -->


<div class="main-content">
  <div class="content-wrapper py-5 px-3">
    <router-outlet></router-outlet>
  </div>
</div>
